
import { CameraLayoutRepository } from 'core/repositories/CameraLayoutRepository';
import { createDependency } from './createDependency';

export const [useCameraLayoutRepository, withCameraLayoutRepository] = createDependency<CameraLayoutRepository>();
